import { useSelector } from 'react-redux'

export const ROLES = Object.freeze({
    ADMIN: 'ADMIN',
    INSTRUCTOR: 'Instructor',
    TA: 'TA',
    STUDENT: 'Student',
})

const extractUser = (userOrUserData) => {
    if (!userOrUserData) return null
    if (userOrUserData.user) return userOrUserData.user
    return userOrUserData
}

export const isAdmin = (userOrUserData) => {
    const user = extractUser(userOrUserData)
    if (!user) return false
    const roleUpper = String(user.role || '')
        .trim()
        .toUpperCase()
    return roleUpper === 'ADMIN' || roleUpper === 'SUPERADMIN'
}

export const isInstructor = (userOrUserData) => {
    const user = extractUser(userOrUserData)
    if (!user) return false
    if (isAdmin(user)) return true // Admin can do everything an Instructor can do
    const roleLower = String(user.role || '')
        .trim()
        .toLowerCase()
    return roleLower === 'instructor'
}

export const isTA = (userOrUserData) => {
    const user = extractUser(userOrUserData)
    if (!user) return false
    if (isInstructor(user)) return true // Admin and Instructor can do everything a TA can do
    const roleLower = String(user.role || '')
        .trim()
        .toLowerCase()
    return roleLower === 'ta'
}

export const isStudent = (userOrUserData) => {
    const user = extractUser(userOrUserData)
    if (!user) return false
    return true // Admin, Instructor, TA, and Student can all do what a Student can do
}

export const useAuthRole = () => {
    const userData = useSelector((state) => state.userData)
    const user = userData?.user
    return {
        userData,
        user,
        isAdmin: isAdmin(user),
        isInstructor: isInstructor(user),
        isTA: isTA(user),
        isStudent: isStudent(user),
    }
}
